import { useRef, useState, useCallback } from 'react';

export const useDraggableScroll = () => {
    const ref = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const startY = useRef(0);
    const scrollTop = useRef(0);
    const isDown = useRef(false);

    const onMouseDown = useCallback((e) => {
        if (!ref.current) return;
        isDown.current = true;
        startY.current = e.pageY - ref.current.offsetTop;
        scrollTop.current = ref.current.scrollTop;
        // Don't set isDragging true immediately to allow clicks
    }, []);

    const onMouseLeave = useCallback(() => {
        isDown.current = false;
        setIsDragging(false);
    }, []);

    const onMouseUp = useCallback(() => {
        isDown.current = false;
        // Small timeout to prevent triggering clicks immediately after drag release
        setTimeout(() => setIsDragging(false), 0); 
    }, []);

    const onMouseMove = useCallback((e) => {
        if (!isDown.current || !ref.current) return;
        e.preventDefault();
        
        const y = e.pageY - ref.current.offsetTop;
        const walk = (y - startY.current) * 1.5; // Scroll speed multiplier
        
        // Threshold to determine if it's a drag or a click
        if (Math.abs(y - startY.current) > 5) {
            setIsDragging(true);
        }

        if (isDown.current) {
            ref.current.scrollTop = scrollTop.current - walk;
        }
    }, []);

    // Style helper to inject into the container
    const dragStyle = {
        cursor: isDragging ? 'grabbing' : 'grab',
        userSelect: 'none', // Prevent text selection
        overflowY: 'auto',   // Ensure it's scrollable
    };

    return {
        ref,
        events: {
            onMouseDown,
            onMouseLeave,
            onMouseUp,
            onMouseMove
        },
        isDragging,
        dragStyle
    };
};
